"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _onEnterPressed = _interopRequireDefault(require("@devsta/on-enter-pressed"));

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("../../../../../../../../../common/utils");

require("../styles/_new-posts-list.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var NewPostsList = /*#__PURE__*/function (_Component) {
  _inherits(NewPostsList, _Component);

  function NewPostsList() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, NewPostsList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(NewPostsList)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "removePostItem", (0, _lodash.default)(function (itemId) {
      return function () {
        var onItemRemove = _this.props.onItemRemove;
        onItemRemove(itemId);
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "selectItem", (0, _lodash.default)(function (itemId) {
      return function () {
        var onItemClick = _this.props.onItemClick;
        onItemClick(itemId);
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "onAddItem", function () {
      var onAddItemClick = _this.props.onAddItemClick;
      onAddItemClick(); // Wait for DOM repaint before scroll

      setTimeout(function () {
        var posts = document.querySelectorAll('.new-posts-list__list-item');
        posts[posts.length - 1].scrollIntoView({
          behavior: 'smooth',
          block: 'end'
        });
      });
    });

    return _this;
  }

  _createClass(NewPostsList, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          postsList = _this$props.postsList,
          selectedItemId = _this$props.selectedItemId;
      return _react.default.createElement("div", {
        className: "new-posts-list"
      }, _react.default.createElement(_commonReact.Form.TitledFormBlock, {
        customContent: true
      }, _react.default.createElement("div", {
        tabIndex: 0,
        onKeyPress: (0, _onEnterPressed.default)({
          onClick: this.onAddItem
        }),
        className: "new-posts-list__add-box",
        onClick: this.onAddItem,
        role: "button"
      }, _react.default.createElement(_uiKit.Icon, {
        name: "addthin",
        size: 20,
        color: "regent"
      })), _react.default.createElement(_commonReact.Form.FormBlockDescription, {
        name: "Create post",
        description: "Add videos",
        hideButton: true
      })), Boolean(postsList.length) && _react.default.createElement("hr", null), postsList.map(function (_ref, index) {
        var itemId = _ref.itemId,
            title = _ref.title,
            assetId = _ref.assetId,
            embedCode = _ref.embedCode,
            thumbnailUrl = _ref.thumbnailUrl;
        return _react.default.createElement("div", {
          key: itemId,
          className: (0, _classnames.default)('new-posts-list__list-item', {
            'new-posts-list__list-item--selected': itemId === selectedItemId
          })
        }, _react.default.createElement(_commonReact.Form.TitledFormBlock, {
          customContent: true
        }, thumbnailUrl || !assetId ? _react.default.createElement(_uiKit.Image, {
          imageUrl: thumbnailUrl,
          width: "75px",
          height: "75px",
          defaultImageIcon: embedCode ? 'embed' : 'projects',
          onClick: _this2.selectItem(itemId),
          backgroundSize: "cover"
        }) : _react.default.createElement("button", {
          type: "button",
          className: "new-posts-list__list-item__asset-preview",
          onClick: _this2.selectItem(itemId)
        }, _react.default.createElement(_commonReact.AssetPreview, {
          assetId: assetId,
          width: "75px",
          height: "75px",
          borderRadius: 0,
          hideFileTypeIcon: true
        })), _react.default.createElement(_commonReact.Form.FormBlockDescription, {
          key: itemId,
          name: title || 'New post',
          description: "SOURCE: ".concat((0, _utils.getInspirationContentSource)({
            assetId: assetId,
            embedCode: embedCode
          })),
          hideButton: true,
          additionalContent: index !== 0 ? _react.default.createElement(_uiKit.Icon, {
            key: itemId,
            name: "trash",
            size: 20,
            onClick: _this2.removePostItem(itemId),
            color: "nevada",
            hoverColor: "redApple"
          }) : null
        })));
      }));
    }
  }]);

  return NewPostsList;
}(_react.Component);

exports.default = NewPostsList;